"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TypeMappingTranslationReducer = exports.TypeMappingReducer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _apiTypeMapping = require("../actions/esdb/apiTypeMapping");

var _nodeToolbox = require("@esnpm/node-toolbox");

var _translate = require("@esnpm/translate");

var TypeMappingReducer = exports.TypeMappingReducer = function TypeMappingReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        data: null,
        loading: false,
        error: null
    };
    var action = arguments[1];

    switch (action.type) {
        case _apiTypeMapping.API_TYPE_MAPPING_SUCCESS:
            var newState = Object.assign({}, state, {
                loading: action.payload.loading,
                error: action.payload.error,
                data: Object.assign({}, state.data)
            });

            Object.entries(action.payload.data).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    k = _ref2[0],
                    v = _ref2[1];

                newState.data[k] = v;
            });
            return newState;
            break;

        default:
            return state;
    }
};

var TypeMappingTranslationReducer = exports.TypeMappingTranslationReducer = function TypeMappingTranslationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        loading: false,
        data: null,
        error: null
    };
    var action = arguments[1];


    switch (action.type) {
        case _apiTypeMapping.API_TYPE_MAPPING_SUCCESS:

            var newState = Object.assign({}, state);
            Object.values(action.payload.data).map(function (set) {
                set.OPTIONS.map(function (opt) {
                    var path = 'typeMapping.' + set.SET + '.' + opt.NAME;
                    newState = (0, _translate.registerTranslation)(newState, path, opt.TRANSLATIONS);
                });
            });

            return newState;
            break;

        default:
            return state;
    }
};